/**
 * Increment or decrement a value within [min, max].
 * wrap=true: overflows wrap around (used for minutes/seconds).
 * wrap=false: clamps at boundaries (used for hours).
 */
export function stepValue(current, delta, min, max, wrap = false) {
  const next = current + delta;
  if (wrap) {
    if (next > max) return min;
    if (next < min) return max;
  }
  return Math.max(min, Math.min(max, next));
}

export const TIMER_PRESETS = [
  { label: '30 s',  hours: 0, minutes: 0, seconds: 30 },
  { label: '1 min', hours: 0, minutes: 1, seconds: 0  },
  { label: '1:30',  hours: 0, minutes: 1, seconds: 30 },
  { label: '2 min', hours: 0, minutes: 2, seconds: 0  },
  { label: '3 min', hours: 0, minutes: 3, seconds: 0  },
  { label: '5 min', hours: 0, minutes: 5, seconds: 0  },
];

/**
 * Returns the index of the preset that matches the given h/m/s, or null.
 */
export function findActivePreset(hours, minutes, seconds) {
  const idx = TIMER_PRESETS.findIndex(
    p => p.hours === hours && p.minutes === minutes && p.seconds === seconds
  );
  return idx === -1 ? null : idx;
}
